import * as React from "react";
import { getImage, getSrc, getSrcSet } from "gatsby-plugin-image";
import { ImageContentCardData } from "types/image-content-card-data";
import { ReactComponent as CaretRight } from "img/arrows/caret-right.svg";

// Use ImageContentCardData type for ImageContentCardProps
const ImageContentCard: React.FC<ImageContentCardData> = ({ cardImage, label, headline, buttonText, buttonUrl, columns }) => {

    const cardImageData = getImage(cardImage || null);

    const cardImgSrc = cardImageData ? getSrc(cardImageData) : '';

    const cardImgSrcSet = cardImageData ? getSrcSet(cardImageData) : '';

    return (
        <div>
            <a className="image-content-card" href={buttonUrl}>
                <div className="image-content-card__image">
                    {cardImage && <img src={cardImgSrc} srcSet={cardImgSrcSet} alt={headline} width={cardImage?.width} height={cardImage?.height} />}
                </div>
                <div className="image-content-card__content">
                    <div className="card-label">{label}</div>
                    <h3 className="card-headline h2">{headline}</h3>
                    {columns === 2 ? (
                        <div className="card-button btn-primary">
                            <span><span data-text={buttonText}>{buttonText}</span></span>
                        </div>
                    ) : (
                        <div className="card-button btn-circle-arrow">
                            <CaretRight />
                        </div>
                    )}
                </div>
            </a>
        </div>
    );
};

export default ImageContentCard;